import { useState } from 'react';
import { useLang, LANG_OPTIONS, hasLangPicked, markLangPicked } from '../context/LanguageContext';
import { isNativeApp } from '../utils/platform.js';
import './LanguagePicker.css';

export default function LanguagePicker() {
  const { switchLang, t } = useLang();
  const [visible, setVisible] = useState(() => !isNativeApp() && !hasLangPicked());

  if (!visible) return null;

  const pick = (code) => {
    switchLang(code);
    markLangPicked();
    setVisible(false);
  };

  return (
    <div className="lang-picker" role="dialog" aria-modal="true" aria-labelledby="lang-picker-title">
      <div className="lang-picker__card">
        <div className="lang-picker__icon" aria-hidden>
          🌐
        </div>
        <h2 id="lang-picker-title" className="lang-picker__title">
          {t.langPickerTitle}
        </h2>
        <p className="lang-picker__subtitle">{t.langPickerSubtitle}</p>

        <div className="lang-picker__grid" role="listbox" aria-label={t.langPickerTitle}>
          {LANG_OPTIONS.map((option) => (
            <button
              key={option.code}
              type="button"
              role="option"
              className="lang-picker__option"
              onClick={() => pick(option.code)}
            >
              <span className="lang-picker__badge">{option.short}</span>
              <span className="lang-picker__label">{option.label}</span>
            </button>
          ))}
        </div>

        <p className="lang-picker__hint">{t.langPickerHint}</p>
      </div>
    </div>
  );
}
